__turbopack_context__.v({
  "className": "hlMjRa_className",
  "variable": "hlMjRa_variable",
});
